import React from 'react';
import { classNames } from 'primereact/utils';

interface LensKPICard {
  value: React.ReactNode;
  label: string;
  /** Dato extra debajo de la etiqueta (p. ej. el tag de sobreturnos). */
  extra?: React.ReactNode;
}

interface LensKPIsProps {
  cards: LensKPICard[];
}

/** KPIs del período elegido (día, semana o mes): una card por dato, con el valor arriba y la etiqueta debajo. */
const LensKPIs: React.FC<LensKPIsProps> = ({ cards }) => {
  return (
    <div className={classNames('agenda-stats', { 'agenda-stats--kpi4': cards.length === 4 })}>
      {cards.map((card) => (
        <div key={card.label} className="nv-card">
          <div className="nv-stack-4 agenda-stats__body">
            <span className="nv-kpi">{card.value}</span>
            <span className="nv-muted">{card.label}</span>
            {card.extra}
          </div>
        </div>
      ))}
    </div>
  );
};

export default LensKPIs;
